import { useCallback } from 'react';
import { useAppSelector, useAppDispatch } from '../../../app/hooks';
import { updateCpsiAccessRequest as ticketUpdate } from '../state';
import { updateCpsiAccessRequest as recurringTaskUpdate } from '../../recurringTasks/state';
import { CpsiAccessRequestView } from '../../../types/shared/accessRequestTypes';
import { EditorMode } from '../types/editorTypes';

/**
 * Custom hook that abstracts Redux state selection and dispatch for
 * CPSI Access editors. Returns the current request data and
 * a mode-aware update function.
 */
export const useCpsiAccessEditor = (mode: EditorMode) => {
  const dispatch = useAppDispatch();

  const request = useAppSelector(state =>
    mode === 'ticket'
      ? state.ticket.currentTicket?.cpsiAccessRequest
      : state.recurringTask.currentRecurringTask?.cpsiAccessRequest
  );

  const updateRequest = useCallback(
    (update: Partial<CpsiAccessRequestView>) => {
      if (mode === 'ticket') {
        dispatch(ticketUpdate(update));
      } else {
        dispatch(recurringTaskUpdate(update));
      }
    },
    [dispatch, mode]
  );

  return { request, updateRequest };
};
